import { c as _c } from "react/compiler-runtime";
import { FileSourceEnum } from '@systemeio/file-manager';
import { FormInput } from '@systemeio/ui';
import { DigitalResourcesTypeEnum } from 'modules/digital-product/enums/digital-resources-type-enum';
import { ResourceFileType } from 'modules/digital-product/hooks/use-resource-files';
import { DigitalProductChangeInterface, DigitalProductErrorInterface } from 'modules/digital-product/types/digital-product-interface';
import ItemSteps from 'modules/stores/store/components/item-steps';
import React, { Dispatch, FC, SetStateAction } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { ProductDownloadItemErrorsType } from '../../../types/product-interface';
import { ConfirmationEmail } from './confirmation-email';
import { FileUploaderWithListedFiles } from 'shared/components/file-uploader/file-uploader-with-listed-files';
type Props = {
  tempProduct: DigitalProductChangeInterface;
  setTempProduct: Dispatch<SetStateAction<DigitalProductChangeInterface>>;
  tempFiles: ResourceFileType[];
  setTempFiles: Dispatch<SetStateAction<ResourceFileType[]>>;
  isResourceFilesLoading?: boolean;
  productItemErrors: Pick<ProductDownloadItemErrorsType, 'digitalProduct.resources'>;
  digitalProductErrors: DigitalProductErrorInterface;
};
export const DigitalDownload: FC<Props> = t0 => {
  const $ = _c(47);
  const {
    tempProduct,
    setTempProduct,
    tempFiles,
    setTempFiles,
    isResourceFilesLoading,
    productItemErrors,
    digitalProductErrors
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.digital_product.select_name");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.funnel.configuration.offer.digital_product_name");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== setTempProduct) {
    t3 = e => setTempProduct(prev => ({
      ...prev,
      name: e.target.value
    }));
    $[4] = setTempProduct;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== digitalProductErrors.name || $[7] !== t2 || $[8] !== t3 || $[9] !== tempProduct.name) {
    t4 = <FormInput label={t2} value={tempProduct.name} onChange={t3} required={true} error={digitalProductErrors.name} />;
    $[6] = digitalProductErrors.name;
    $[7] = t2;
    $[8] = t3;
    $[9] = tempProduct.name;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t4) {
    t5 = {
      key: "digital download",
      title: t1,
      element: t4
    };
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("dashboard.digital_product.resources.digital_download.upload_resources");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  let t8;
  if ($[16] !== setTempFiles || $[17] !== setTempProduct) {
    t7 = file => {
      setTempFiles(prev_0 => [...prev_0, file]);
      setTempProduct(prev_1 => ({
        ...prev_1,
        resources: [...prev_1.resources, {
          type: DigitalResourcesTypeEnum.downloadable_file,
          dataFile: file.id
        }]
      }));
    };
    t8 = file_0 => {
      setTempFiles(prev_2 => prev_2.filter(item => item.id !== file_0.id));
      setTempProduct(prev_3 => ({
        ...prev_3,
        resources: prev_3.resources.filter(item_0 => {
          if (item_0.type === DigitalResourcesTypeEnum.downloadable_file) {
            return item_0.dataFile !== file_0.id;
          }
          return true;
        })
      }));
    };
    $[16] = setTempFiles;
    $[17] = setTempProduct;
    $[18] = t7;
    $[19] = t8;
  } else {
    t7 = $[18];
    t8 = $[19];
  }
  const t9 = digitalProductErrors.resources.length === 1 && typeof digitalProductErrors.resources[0] === "string" ? digitalProductErrors.resources[0] : productItemErrors["digitalProduct.resources"];
  let t10;
  if ($[20] !== digitalProductErrors.resources) {
    t10 = digitalProductErrors.resources.map(_temp);
    $[20] = digitalProductErrors.resources;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== isResourceFilesLoading || $[23] !== t10 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9 || $[27] !== tempFiles) {
    t11 = <FileUploaderWithListedFiles source={FileSourceEnum.DigitalProductResource} files={tempFiles} isPreFetching={isResourceFilesLoading} onSelect={t7} onDelete={t8} error={t9} errors={t10} />;
    $[22] = isResourceFilesLoading;
    $[23] = t10;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = tempFiles;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11 || $[30] !== t6) {
    t12 = {
      key: "resources",
      title: t6,
      element: t11
    };
    $[29] = t11;
    $[30] = t6;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t) {
    t13 = t("dashboard.store.product.download.confirmation_email.title");
    $[32] = t;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== setTempProduct) {
    t14 = confirmationEmail => setTempProduct(prev_4 => ({
      ...prev_4,
      confirmationEmail
    }));
    $[34] = setTempProduct;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== digitalProductErrors.confirmationEmail || $[37] !== t14 || $[38] !== tempProduct.confirmationEmail) {
    t15 = <ConfirmationEmail confirmationEmail={tempProduct.confirmationEmail} onChange={t14} errors={digitalProductErrors.confirmationEmail} />;
    $[36] = digitalProductErrors.confirmationEmail;
    $[37] = t14;
    $[38] = tempProduct.confirmationEmail;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t13 || $[41] !== t15) {
    t16 = {
      key: "confirmation email",
      title: t13,
      element: t15
    };
    $[40] = t13;
    $[41] = t15;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t12 || $[44] !== t16 || $[45] !== t5) {
    t17 = <ItemSteps steps={[t5, t12, t16]} />;
    $[43] = t12;
    $[44] = t16;
    $[45] = t5;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  return t17;
};
function _temp(error) {
  if (typeof error === "object") {
    return Object.values(error).join(" ");
  }
}